import React from 'react';

const SupplyCategoryList = ({ categories, onDelete }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">Categorías de Insumos</h3>
      {categories.length === 0 ? (
        <p className="text-gray-500">No hay categorías de insumos registradas</p>
      ) : (
        <ul className="divide-y divide-gray-200">
          {categories.map((category) => (
            <li key={category.id} className="py-3 flex justify-between items-center">
              <span className="text-gray-700">{category.name}</span>
              <button
                onClick={() => onDelete(category.id)}
                className="text-red-500 hover:text-red-700 transition duration-200"
              >
                Eliminar
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SupplyCategoryList;